import styled from 'styled-components'

import { getByListSummary } from '@/app/2023/consejo/candidatos/components/ByListSummary'
import { IGanador } from '@/app/2023/consejo/consejeros/types/ganadores'
import circunscripciones from '@/app/2023/consejo/types/circunscripciones'
import ICandidato from '@/app/2023/consejo/types/ICandidato'
import TableBase from '@/app/components/Table'
import { HeaderCell } from '@/app/components/Table/Headers'
import { RowCell } from '@/app/components/Table/Row'
import { colors, spaces } from '@/config/global-parameters'

import normalizeText from './helper'
import getTableColumns, { IResultadoCircunscripcion } from './tableColumns'

export interface ICircumscriptionTable {
  className?: string
  selectedUnit: string
  inputFilter: string
  ganadores: IGanador[]
  candidatos: ICandidato[]
}

const getPoliticalList = (candidate: ICandidato) => {
  const listSummaryQuery = getByListSummary({
    filters: {},
    selected: [candidate],
  })
  const thisPoliticalList: string = listSummaryQuery.filter((thisList) => thisList.size === 1)
    .map((thisList) => thisList.id)[0]
    || ''

  return thisPoliticalList
}

const mapData = ({
  candidatos,
  ganadores,
}: {
  ganadores: IGanador[]
  candidatos: ICandidato[]
}) => {
  circunscripciones[15].name = 'Magallanes y ACh.'

  const initialResults: { [key: number | string]: IResultadoCircunscripcion } = Object.keys(
    circunscripciones
  )
    .reduce((acc: { [key: number | string]: IResultadoCircunscripcion }, key) => {
      if (key !== '17') {
        acc[key] = {
          circunscripcion: circunscripciones[key],
          id: key,
          name: circunscripciones[key].name,
          votos: {
            0: 0,
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            6: 0,
            totales: 0,
          },
        }
      }
      return acc
    }, {})

  const finalResults = ganadores.reduce((resultados, winner) => {
    const thisCandidate = candidatos.find((candidate) => candidate.id === winner.id)
    if (!thisCandidate) return resultados
    if (thisCandidate.circunscripcion === '17') return resultados

    const thisList: string = getPoliticalList(thisCandidate)
    const updatedResultados = { ...resultados }
    // TODO: Remover el *3000 cuando se reciban los datos del backend
    updatedResultados[thisCandidate.circunscripcion].votos[thisList] += winner.votos
    updatedResultados[thisCandidate.circunscripcion].votos.totales += winner.votos
    return updatedResultados
  }, initialResults)

  const sortedResults = Object.values(finalResults)
    .sort(
      (a, b) => a.circunscripcion.order - b.circunscripcion.order
    )
  return sortedResults
}

const CircumscriptionTable = ({
  candidatos,
  className,
  ganadores,
  inputFilter,
  selectedUnit,
}: ICircumscriptionTable) => {
  let tableCircumscriptionData = [...mapData({ candidatos, ganadores })]
  if (inputFilter) {
    tableCircumscriptionData = tableCircumscriptionData.filter((resultado) =>
      normalizeText(resultado.circunscripcion.name)
        ?.includes(normalizeText(inputFilter))
    )
  }

  return (
    <Wrapper className={className}>
      <Table
        columns={getTableColumns(selectedUnit)}
        data={tableCircumscriptionData}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaces.s};
  width: 100%;
`

const Table = styled(TableBase)`
  overflow-y: auto;
  width: 100%;
  ${HeaderCell} {
    display: flex;
    justify-content: center;
    text-align: center;
    background-color: white;
    &:first-child {
      justify-content: start;
      padding-left: 62px;
    }
    @media (max-width: ${spaces.tabletBreakpoint}) {
      border-right: 0.5px solid ${colors.colorBlack};
      &:first-child {
        padding: ${spaces.xs};
        z-index: 1;
        position: sticky;
        top: 0;
        left: 0;
        box-shadow: 0px 19px 20px 0px rgba(0, 0, 0, 0.3);
      }
    }
  }
  ${RowCell} {
    padding: ${spaces.s} ${spaces.s};
    min-height: 0px;
    font-size: 13px;
    &:first-child {
      white-space: nowrap;
    }
    @media (max-width: ${spaces.tabletBreakpoint}) {
      background-color: ${colors.colorWhite};
      border-right: 0.5px solid ${colors.colorBlack};
      &:first-child {
        padding: ${spaces.xs};
        z-index: 1;
        position: sticky;
        top: 0;
        left: 0;
        box-shadow: 0px 19px 20px 0px rgba(0, 0, 0, 0.3);
        white-space: normal;
      }
    }
  }
`

export default CircumscriptionTable
